/* ═══════════════════════════════════════════════════════════
   DARF: Tagesportions-Rechner auf der Produktseite
   (funktioniert ohne Login, wird mit Login nur bequemer)

   RER = 70 × kg^0.75
   MER = RER × Faktor
   Gramm/Tag = MER × 1000 / kcal_per_kg

   Der Faktor haengt am Tier. Bis zum 21.09.2026 kannte diese
   Datei nur Hundefaktoren und begruesste auch auf dem
   Katzenfutter mit "Hundename": eine 4-kg-Katze bekam damit
   rund 320 statt 240 kcal am Tag empfohlen, also ein Drittel
   zu viel.

   Beide Staffeln sind die MER-Tabelle von DARF, dieselbe, mit
   der der Matcher auf der Startseite rechnet
   (assets/darf-matcher.js), Waltham/NRC:

                            Hund   Katze
     Welpe bis 4 Monate      3,0     2,5
     Welpe 4 bis 12 Monate   2,0     2,0
     Erwachsen, ruhig        1,4     1,1
     Erwachsen, normal       1,6     1,2
     Erwachsen, aktiv        2,0     1,4
     Senior ab 7 Jahren      1,4     1,1
     Abnehmen                1,0     0,8

   Nichts daneben. Bis zum 21.09.2026 standen hier beim Hund
   noch 1,2 fuer Uebergewicht, 1,8 fuer aktiv, 2,0 fuer den
   Arbeitshund und 2,5 fuer den Welpen ab vier Monaten, alle
   vier frei erfunden: der Welpe bekam damit rund ein Fuenftel
   zu viel. Zwei Rechner im selben Shop duerfen demselben Tier
   nicht zwei Mengen nennen, und keiner von beiden eine Zahl,
   die nirgends steht.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SPECIES = {
    dog: {
      nameLabel: 'Hundename',
      namePlaceholder: 'z. B. Rex',
      weightPlaceholder: 'z. B. 12',
      genericResult: 'Empfehlung für deinen Hund',
      infoName: 'deines Hundes',
      petsLabel: { one: 'Dein Hund', many: 'Deine Hunde' },
      options: [
        { v: 'ruhig',  f: 1.4, t: 'Erwachsen, ruhig oder kastriert (×1.4)' },
        { v: 'normal', f: 1.6, t: 'Erwachsen, normal aktiv (×1.6)', sel: true },
        { v: 'aktiv',  f: 2.0, t: 'Erwachsen, aktiv (×2.0)' },
        { v: 'senior', f: 1.4, t: 'Senior (ab 7 Jahren) (×1.4)' },
        { v: 'jung',   f: 2.0, t: 'Welpe (4 bis 12 Monate) (×2.0)' },
        { v: 'welpe',  f: 3.0, t: 'Welpe (bis 4 Monate) (×3.0)' },
        { v: 'diaet',  f: 1.0, t: 'Abnehmen, Diät (×1.0)' }
      ],
      levels: [
        ['Erwachsen, ruhig oder kastriert', '×1.4'],
        ['Erwachsen, normal aktiv', '×1.6'],
        ['Erwachsen, aktiv', '×2.0'],
        ['Senior (ab 7 Jahren)', '×1.4'],
        ['Welpe (4 bis 12 Monate)', '×2.0'],
        ['Welpe (bis 4 Monate)', '×3.0'],
        ['Abnehmen, Diät', '×1.0']
      ],
      /* Aus dem Profil: Woerter aus dem Tierprofil, Zahlen aus
         aelteren Eintraegen. Was hier nicht steht, faellt auf
         den Standardwert zurueck. */
      fromProfile: { low: 'ruhig', moderate: 'normal', normal: 'normal', active: 'aktiv', very_active: 'aktiv', working: 'aktiv', senior: 'senior', puppy: 'jung' },
      youngMonths: [[4, 'welpe'], [12, 'jung']]
    },
    cat: {
      nameLabel: 'Katzenname',
      namePlaceholder: 'z. B. Minka',
      weightPlaceholder: 'z. B. 4',
      genericResult: 'Empfehlung für deine Katze',
      infoName: 'deiner Katze',
      petsLabel: { one: 'Deine Katze', many: 'Deine Katzen' },
      options: [
        { v: 'ruhig',  f: 1.1, t: 'Erwachsen, ruhig (Wohnungskatze) (×1.1)' },
        { v: 'normal', f: 1.2, t: 'Erwachsen, normal aktiv (×1.2)', sel: true },
        { v: 'aktiv',  f: 1.4, t: 'Erwachsen, aktiv (Freigängerin) (×1.4)' },
        { v: 'senior', f: 1.1, t: 'Senior (ab 7 Jahren) (×1.1)' },
        { v: 'jung',   f: 2.0, t: 'Junge Katze (4 bis 12 Monate) (×2.0)' },
        { v: 'kitten', f: 2.5, t: 'Kätzchen (bis 4 Monate) (×2.5)' },
        { v: 'diaet',  f: 0.8, t: 'Abnehmen, Diät (×0.8)' }
      ],
      levels: [
        ['Erwachsen, ruhig (Wohnungskatze)', '×1.1'],
        ['Erwachsen, normal aktiv', '×1.2'],
        ['Erwachsen, aktiv (Freigängerin)', '×1.4'],
        ['Senior (ab 7 Jahren)', '×1.1'],
        ['Junge Katze (4 bis 12 Monate)', '×2.0'],
        ['Kätzchen (bis 4 Monate)', '×2.5'],
        ['Abnehmen, Diät', '×0.8']
      ],
      fromProfile: { indoor: 'ruhig', low: 'ruhig', in_out: 'normal', moderate: 'normal', normal: 'normal', outdoor: 'aktiv', active: 'aktiv', very_active: 'aktiv', senior: 'senior', kitten: 'kitten' },
      youngMonths: [[4, 'kitten'], [12, 'jung']]
    }
  };

  var PETS_BOTH_LABEL = { one: 'Dein Tier', many: 'Deine Tiere' };
  var STORE_KEY = 'darf:ppc:last';

  document.querySelectorAll('[data-ppc]').forEach(initCalc);

  function initCalc(root) {
    var kcalPerKg = parseFloat(root.dataset.kcalPerKg) || 3700;
    var packG     = parseFloat(root.dataset.packG)     || 4000;
    var handle    = root.dataset.productHandle;
    var mode      = root.dataset.speciesMode || 'dog';   // dog | cat | both

    var form   = root.querySelector('[data-ppc-form]');
    var result = root.querySelector('[data-ppc-result]');
    if (!form || !result) return;

    var nameLabel = root.querySelector('[data-ppc-name-label]');
    var nameInput = root.querySelector('[data-ppc-name-input]');
    var weightEl  = root.querySelector('[data-ppc-weight]');
    var activity  = root.querySelector('[data-ppc-activity]');
    var levelsEl  = root.querySelector('[data-ppc-levels]');
    var infoName  = root.querySelector('[data-ppc-info-name]');
    var petsBox   = root.querySelector('[data-ppc-pets]');
    var petsRow   = root.querySelector('[data-ppc-pets-row]');
    var petsLbl   = petsBox ? petsBox.querySelector('.ppc__label') : null;

    var species = mode === 'cat' ? 'cat' : 'dog';
    var pets = [];
    var selectedPetId = null;

    applySpecies(species, null);
    restore();

    root.querySelectorAll('[data-ppc-species]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.ppcSpecies === species) return;
        applySpecies(btn.dataset.ppcSpecies, null);
        selectedPetId = null;
        renderPets();
        result.hidden = true;
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      calculate();
    });

    loadPets();

    /* ── Tierart setzen ───────────────────────────────────── */
    function applySpecies(next, keepActivity) {
      species = SPECIES[next] ? next : 'dog';
      var cfg = SPECIES[species];

      if (nameLabel) nameLabel.textContent = cfg.nameLabel;
      if (nameInput) nameInput.placeholder = cfg.namePlaceholder;
      if (weightEl)  weightEl.placeholder  = cfg.weightPlaceholder;
      if (infoName)  infoName.textContent  = cfg.infoName;

      if (activity) {
        activity.innerHTML = '';
        var lead = document.createElement('option');
        lead.value = '';
        lead.textContent = 'Aktivitätslevel wählen';
        activity.appendChild(lead);
        cfg.options.forEach(function (o) {
          var el = document.createElement('option');
          el.value = o.v;
          el.textContent = o.t;
          if (o.sel) el.selected = true;
          activity.appendChild(el);
        });
        if (keepActivity && hasOption(keepActivity)) activity.value = keepActivity;
      }

      if (levelsEl) {
        levelsEl.innerHTML = '';
        cfg.levels.forEach(function (row) {
          var tr = document.createElement('tr');
          var a = document.createElement('td'); a.textContent = row[0];
          var b = document.createElement('td'); b.textContent = row[1];
          tr.appendChild(a); tr.appendChild(b);
          levelsEl.appendChild(tr);
        });
      }

      root.querySelectorAll('[data-ppc-species]').forEach(function (btn) {
        var on = btn.dataset.ppcSpecies === species;
        btn.classList.toggle('is-active', Boolean(on));
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function hasOption(value) {
      return SPECIES[species].options.some(function (o) { return o.v === String(value); });
    }

    /* Der Faktor steht in der Konfiguration, nicht im Wert des Feldes. Bei der
       Katze tragen "ruhig" und "Senior" denselben Faktor 1,1 und muessen
       trotzdem zwei Eintraege bleiben. */
    function factorOf(value) {
      var hit = null;
      SPECIES[species].options.forEach(function (o) { if (o.v === String(value)) hit = o; });
      return hit ? hit.f : NaN;
    }

    /* ── Tiere aus dem Profil ─────────────────────────────── */
    function loadPets() {
      var auth = window.__darfAuth;
      if (!auth || !petsBox || !petsRow) return;
      Promise.resolve(auth.ready).then(function () {
        if (!auth.token) return null;
        return fetch(auth.api + '/accounts/pets', { headers: { Authorization: 'Bearer ' + auth.token } })
          .then(function (r) { return r.ok ? r.json() : null; });
      }).then(function (d) {
        // Nur Tiere mit Gewicht: ohne Gewicht fuellt ein Chip kein Feld
        // und verspricht mehr, als er halten kann.
        pets = ((d && d.pets) || []).filter(function (p) { return p && p.weight_g > 0; });
        renderPets();
      }).catch(function () { /* nicht angemeldet oder Profil leer: Rechner bleibt wie er ist */ });
    }

    function petsForSpecies() {
      // Auf einem Produkt fuer beide zeigen wir alle Tiere, und der Klick
      // stellt die Tierart mit ein. Sonst nur die, um die es hier geht.
      if (mode === 'both') return pets;
      return pets.filter(function (p) { return speciesOf(p) === species; });
    }

    function speciesOf(pet) {
      return String(pet.species || 'dog').toLowerCase() === 'cat' ? 'cat' : 'dog';
    }

    function renderPets() {
      if (!petsBox || !petsRow) return;
      var list = petsForSpecies();
      petsRow.innerHTML = '';
      if (!list.length) { petsBox.hidden = true; return; }

      if (petsLbl) {
        var kinds = {};
        list.forEach(function (p) { kinds[speciesOf(p)] = true; });
        // Hund und Katze im selben Haushalt: dann heisst es "Tiere".
        var words = (kinds.dog && kinds.cat) ? PETS_BOTH_LABEL : SPECIES[speciesOf(list[0])].petsLabel;
        petsLbl.textContent = list.length > 1 ? words.many : words.one;
      }

      list.forEach(function (p) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ppc__pet' + (p.id === selectedPetId ? ' is-active' : '');
        b.dataset.petId = p.id;
        b.setAttribute('aria-pressed', p.id === selectedPetId ? 'true' : 'false');
        b.textContent = p.name;
        b.addEventListener('click', function () { usePet(p); });
        petsRow.appendChild(b);
      });
      petsBox.hidden = false;
    }

    function usePet(pet) {
      selectedPetId = pet.id;
      var want = speciesOf(pet);
      if (want !== species) applySpecies(want, null);

      if (nameInput) nameInput.value = pet.name || '';
      if (weightEl && pet.weight_g > 0) weightEl.value = Math.round(pet.weight_g / 100) / 10;

      var factor = profileFactor(pet);
      if (activity && factor) activity.value = factor;

      renderPets();
      calculate();
    }

    /* Aktivitaetsfaktor aus dem Profil. Ein junges Tier schlaegt die
       Aktivitaet: ein Welpe frisst mehr als ein ruhiger Ersthund, egal
       was im Feld steht. */
    function profileFactor(pet) {
      var cfg = SPECIES[speciesOf(pet)];
      var months = ageMonths(pet.birthdate);
      if (months != null) {
        for (var i = 0; i < cfg.youngMonths.length; i++) {
          if (months < cfg.youngMonths[i][0]) return cfg.youngMonths[i][1];
        }
      }
      var raw = pet.activity_level;
      if (raw == null || raw === '') return null;
      var key = String(raw).trim().toLowerCase();
      if (cfg.fromProfile[key]) return cfg.fromProfile[key];
      var num = parseFloat(key);
      if (!isFinite(num)) return null;
      // Aeltere Profile haben die Zahl gespeichert, die im alten
      // Hunde-Rechner stand. Auf die naechste vorhandene Stufe runden.
      var best = null, dist = Infinity;
      cfg.options.forEach(function (o) {
        var d = Math.abs(o.f - num);
        if (d < dist) { dist = d; best = o.v; }
      });
      return best;
    }

    function ageMonths(birthdate) {
      if (!birthdate) return null;
      var d = new Date(birthdate);
      if (isNaN(d.getTime())) return null;
      var ms = Date.now() - d.getTime();
      if (ms < 0) return null;
      return ms / (1000 * 60 * 60 * 24 * 30.4375);
    }

    /* ── Speicher ─────────────────────────────────────────── */
    function restore() {
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem(STORE_KEY)); } catch (_) {}
      if (!saved) return;
      // Auf einem Produkt fuer beide darf der letzte Besuch die Tierart
      // setzen; auf einem Katzenprodukt niemals.
      if (mode === 'both' && saved.species && SPECIES[saved.species]) applySpecies(saved.species, null);
      var name = saved.pet_name || saved.dog_name;
      if (name && nameInput) nameInput.value = name;
      if (saved.weight && weightEl) weightEl.value = saved.weight;
      if (saved.meals && form.elements.meals) form.elements.meals.value = saved.meals;
      // Der Faktor bedeutet je Tierart etwas anderes: 1,6 ist beim Hund
      // normal aktiv, bei der Katze gibt es ihn gar nicht.
      if (saved.activity && saved.species === species && hasOption(saved.activity)) {
        activity.value = saved.activity;
      }
    }

    function remember(name, weightKg, meals, level) {
      try {
        localStorage.setItem(STORE_KEY, JSON.stringify({
          species: species, pet_name: name, weight: weightKg, meals: meals,
          activity: String(level), handle: handle, savedAt: Date.now()
        }));
      } catch (_) {}
    }

    /* ── Rechnen ──────────────────────────────────────────── */
    function calculate() {
      var name     = (nameInput && nameInput.value || '').trim();
      var weightKg = parseFloat(weightEl.value);
      var meals    = parseInt(form.elements.meals.value, 10) || 2;
      var factor   = factorOf(activity.value);

      if (!isFinite(weightKg) || weightKg <= 0) { weightEl.focus(); return; }
      if (!isFinite(factor) || factor <= 0) { activity.focus(); return; }

      var rer = 70 * Math.pow(weightKg, 0.75);
      var mer = rer * factor;
      var gramsPerDay = (mer * 1000) / kcalPerKg;

      result.querySelector('[data-ppc-result-name]').textContent =
        name ? ('Empfehlung für ' + name) : SPECIES[species].genericResult;
      result.querySelector('[data-ppc-grams]').textContent    = Math.round(gramsPerDay);
      result.querySelector('[data-ppc-per-meal]').textContent = Math.round(gramsPerDay / meals);
      result.querySelector('[data-ppc-supply]').textContent   = Math.floor(packG / gramsPerDay);
      result.querySelector('[data-ppc-mer]').textContent      = Math.round(mer);

      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      remember(name, weightKg, meals, activity.value);
    }
  }
})();
